import styled from 'styled-components';

export const PopularQuestionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: space-between;

  button {
    margin: 8px;
  }
`;

export const SubSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  text-align: center;
  padding: 8px 0;

  .title {
    text-align: left;
    margin: 0;
    font-size: 18px !important;
    padding: 0 16px;
    display: block;
    font-weight: 500;

    img {
      width: 24px;
      display: inline-block;
      margin-right: 8px;
      vertical-align: -6px;
    }
  }
`;

export const QuestionList = styled.ul`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0;
  color: #4c4c4c;
  font-size: 16px;
  font-weight: lighter;

  li {
    width: 100%;
    height: auto;
    white-space: break-spaces;
    text-align: left;
    cursor: pointer;
    list-style: none;
    padding: 6px 16px;
  }

  li:hover {
    background-color: #eee;
  }

  li:not(:last-child) {
    border-bottom: 1px solid #ccc;
  }

  li.disabled {
    cursor: not-allowed;
  }
`;
